import { AdcashGuruTargetPickMetrics } from '../../../../types/adcash.types';
import GuruPage from '../../../../components/adcash/guru/GuruPage';
import AdcashGuruDashboard from '../../../../components/adcash/guru/AdcashGuruDashboard';
import AdcashGuruTargetpickMetricsTable from '../../../../components/adcash/guru/table/AdcashGuruTargetpickMetricsTable';

const INITIAL: AdcashGuruTargetPickMetrics = {
  prevTotalRevenue: 0, prevTotalReq: 0, prevTotalView: 0, prevTotalImp: 0, prevTotalClk: 0,
  totalRevenue: 0, totalReq: 0, totalView: 0, totalImp: 0, totalClk: 0,
  dailyStats: [],
};

export default function GuruTargetPick() {
  return (
    <GuruPage
      apiSlug="targetpick"
      initialMetrics={INITIAL}
      renderDashboard={(data) => <AdcashGuruDashboard dailyStats={data.dailyStats} />}
      renderTable={(data) => <AdcashGuruTargetpickMetricsTable data={data} />}
      tableWidth="1300px"
    />
  );
}
